/**
 * Created by ppatton on 1/26/2017.
 */

import { LMFormatterService } from './lm-formatter.service';

export const lmFavoriteFormatter = (
  lmFormatterService: LMFormatterService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  let hasEditable = false;
  let isEditable = false;

  if (dataView.isTreeMoreLink) {
    return lmFormatterService.getMoreLink(cell, dataView);
  }

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      return '';
    }
  }

  // make readonly when an editability function exists and it returns a false
  if (columnDef.isEditable) {
    hasEditable = true;
    isEditable = columnDef.isEditable(row, cell, value, columnDef, dataView, dataGrid);
  }

  // TODO: CAL - a readonly favorite?
  // if (hasEditable && !isEditable) {
  //   return Soho.Formatters.Readonly(row, cell, markup);
  // }

  const checkedState: boolean = (!value ? false : value === true);
  if (columnDef.displayField.displayAsStar) {
    return Soho.Formatters.Favorite(row, cell, value, columnDef, dataView, dataGrid);
  } else {
    return Soho.Formatters.Checkbox(row, cell, value, columnDef, dataView, dataGrid);
  }
};
